import React from "react";
import { Col, Row, Card, CardBody, CardTitle, Collapse } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import config from "config";
import {
  FiLink,
  FiDollarSign,
  FiCalendar,
  FiInfo,
  FiUser,
  FiCreditCard,
  FiTrendingUp,
  FiGlobe,
  FiChevronDown,
  FiChevronUp,
  FiTable,
  FiEye,
} from "react-icons/fi";

const TableComponent = ({
  header,
  data,
  title,
  details,
  ids,
  isAccordionOpen = true,
  setIsAccordionOpen = () => {},
}) => {
  const Config = config;
  const { url: backUrl, apiName: api, appName } = Config;

  // Fonction pour basculer l'état du collapse
  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  return (
    <Col sm="12">
      <Card
        className="shadow-sm border-0 overflow-hidden"
        style={{ borderRadius: "12px" }}
      >
        {/* En-tête cliquable - identique à HmfEdit */}
        <div
          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
          style={{
            background: "#555B21",
            letterSpacing: "0.5px",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={toggleAccordion}
        >
          <div className="d-flex align-items-center">
            {/* <FiTable size={16} className="me-2" /> */}
            <span style={{ fontSize: "0.82rem" }}>{title}</span>
          </div>
          {isAccordionOpen ? (
            <FiChevronUp size={16} />
          ) : (
            <FiChevronDown size={16} />
          )}
        </div>

        {/* Contenu repliable */}
        <Collapse isOpen={isAccordionOpen}>
          <CardBody className="p-0">
            {/* Section détails sous forme de tableau - similaire à HmfEdit */}
            {details && (
              <div className="table-responsive" style={{ margin: 0 }}>
                <table
                  className="table table-bordered rounded-0 overflow-hidden fx-table-sm mb-0"
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    fontSize: "0.8rem",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          background: "#555B21",
                          color: "white",
                          verticalAlign: "top",
                          padding: "8px",
                          fontSize: "0.75rem",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          border: "none",
                          width: "30%",
                        }}
                      >
                        Propriété
                      </th>
                      <th
                        style={{
                          background: "#555B21",
                          color: "white",
                          verticalAlign: "top",
                          padding: "8px",
                          fontSize: "0.75rem",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          border: "none",
                        }}
                      >
                        Valeur
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(details)
                      .filter(
                        ([key, value]) =>
                          typeof value !== "object" || value === null
                      )
                      .map(([key, value], index) => (
                        <tr
                          key={index}
                          style={{ transition: "all 0.15s ease" }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#ffff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "white";
                          }}
                        >
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #e9ecef",
                              backgroundColor: "inherit",
                              fontWeight: "500",
                              color: "#495057",
                            }}
                          >
                            {key}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #e9ecef",
                              backgroundColor: "inherit",
                            }}
                          >
                            <div
                              style={{
                                padding: "4px 8px",
                                backgroundColor: "#ffff",
                                borderRadius: "6px",
                                border: "1px solid #e9ecef",
                                minHeight: "32px",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "0.8rem",
                              }}
                            >
                              {renderValue(key, value, ids, appName, backUrl)}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Séparateur si détails et données */}
            {details && data.length > 0 && (
              <div
                style={{
                  height: "1px",
                  backgroundColor: "#e9ecef",
                  margin: "0",
                }}
              />
            )}

            {/* Section tableau principal - stylé comme HmfEdit */}
            <div className="table-responsive" style={{ margin: 0 }}>
              <table
                className="table table-bordered rounded-0 overflow-hidden fx-table-sm mb-0"
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  fontSize: "0.8rem",
                }}
              >
                <thead>
                  <tr>
                    {header.map((columnName, index) => (
                      <th
                        key={index}
                        style={{
                          background: "#555B21",
                          color: "white",
                          verticalAlign: "top",
                          padding: "8px",
                          fontSize: "0.75rem",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          border: "none",
                          minWidth: "7em",
                          maxWidth: "12em",
                        }}
                      >
                        {columnName}
                      </th>
                    ))}
                    <th
                      style={{
                        background: "#555B21",
                        padding: "8px",
                        width: "1%",
                        border: "none",
                      }}
                    >
                      <FiEye size={14} style={{ visibility: "hidden" }} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td
                        colSpan={header.length + 1}
                        style={{
                          padding: "24px 8px",
                          textAlign: "center",
                          backgroundColor: "#ffff",
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-center flex-column text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          <i
                            className="mdi mdi-alert-circle-outline mb-2"
                            style={{ fontSize: "2rem", opacity: 0.5 }}
                          />
                          <span style={{ fontWeight: "500" }}>
                            {localStorage.getItem("i18nextLng") === "en"
                              ? "No data to display"
                              : "Pas de données à afficher"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    data.map((rowData, index) => (
                      <tr
                        key={index}
                        style={{ transition: "all 0.15s ease" }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        {Object.entries(rowData).map(([key, value]) =>
                          key !== "index" && key !== "id" ? (
                            <td
                              key={key}
                              style={{
                                padding: "8px",
                                border: "1px solid #e9ecef",
                                backgroundColor: "inherit",
                              }}
                            >
                              <div
                                style={{
                                  cursor: "default",
                                  padding: "4px 8px",
                                  backgroundColor: "#ffff",
                                  borderRadius: "6px",
                                  border: "1px solid #e9ecef",
                                  minHeight: "32px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "0.8rem",
                                  transition: "all 0.2s ease",
                                  textAlign:
                                    [
                                      "position_signature",
                                      "threshold",
                                      "instalment",
                                      "instalment_date",
                                      "availability_date",
                                      "date_maturity",
                                      "drawdown_end_date",
                                      "non_utilization_fees",
                                    ].includes(key) || typeof value === "number"
                                      ? "right"
                                      : "left",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#e9ecef";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = "#ffff";
                                }}
                              >
                                {renderTableValue(key, value)}
                              </div>
                            </td>
                          ) : null
                        )}
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #e9ecef",
                            backgroundColor: "#f8f9fa",

                            width: "1%",
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                          }}
                        >
                          <FiEye size={14} style={{ visibility: "hidden" }} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};

// Fonction renderValue inchangée
const renderValue = (key, value, ids, appName, backUrl) => {
  if (!value && value !== 0)
    return <span className="text-muted fst-italic">—</span>;

  const LinkWrapper = ({ to, onClick, children }) => (
    <Link
      to={to}
      onClick={onClick}
      className="text-decoration-none fw-medium text-primary d-inline-flex align-items-center"
      style={{
        transition: "all 0.2s ease",
        fontSize: "0.8rem",
      }}
    >
      <FiLink size={9} className="me-1" />
      {children}
    </Link>
  );

  const formatNum = (val, decimals) => (
    <span style={{ fontSize: "0.8rem" }}>
      {(
        Math.floor(val * Math.pow(10, decimals)) / Math.pow(10, decimals)
      ).toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
      })}{" "}
    </span>
  );

  // Formatage des nombres
  if (typeof value === "number") {
    if (key === "Price per share") return formatNum(value, 4);
    if (key === "Share nav" || key === "Investment nav" || key.includes("Rate"))
      return formatNum(value, 6);
    if (
      !["Builder", "Price per share", "Share nav", "Rate MUR → EUR"].includes(
        key
      ) &&
      !key.includes("Rate")
    ) {
      return formatNum(value, 2);
    }
  }

  // Liens
  const linkMap = {
    Instrument: ids?.product_id && `/${appName}/products/${ids.product_id}`,
    "Related Loan":
      ids?.product2_id && `/${appName}/products/${ids.product2_id}`,
    "Asset account":
      ids?.asset_account_id &&
      `/${appName}/asset_accounts/${ids.asset_account_id}`,
    Entity: ids?.entity_id && `/${appName}/entities/${ids.entity_id}`,
    Currency: ids?.currency_id && `/${appName}/currencies/${ids.currency}`,
  };

  if (linkMap[key]) {
    return <LinkWrapper to={linkMap[key]}>{value}</LinkWrapper>;
  }

  if (
    (key === "Collateral" || key === "Related collateral") &&
    ids?.collateral_id
  ) {
    return (
      <LinkWrapper
        to={`/${appName}/collaterals/${ids.collateral_id}`}
        onClick={(e) => {
          e.preventDefault();
          window.location.href = `${backUrl}/collaterals/${ids.collateral_id}`;
        }}
      >
        {value}
      </LinkWrapper>
    );
  }

  // Badges
  const badges = {
    Alive: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    "Dossier complet": {
      bg: "linear-gradient(135deg, #33A133, #28a745)",
      color: "white",
    },
    "Dossier validé": {
      bg: "linear-gradient(135deg, #66C266, #33A133)",
      color: "white",
    },
    Terminated: {
      bg: "linear-gradient(135deg, #dc3545, #fd7e14)",
      color: "white",
    },
  };

  const pendingStates = [
    "En attente",
    "Commercialisation",
    "Optionnelle - à confirmer",
    "En cours",
  ];

  if (badges[value] || pendingStates.includes(value)) {
    const style = badges[value] || {
      bg: "linear-gradient(135deg, #17a2b8, #6f42c1)",
      color: "white",
    };
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: style.bg,
          color: style.color,
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (value === true)
    return <span className="text-success fw-semibold">✓</span>;
  if (value === false)
    return <span className="text-danger fw-semibold">✗</span>;

  return <span className="text-dark">{value}</span>;
};

// Fonction renderTableValue inchangée
const renderTableValue = (key, value) => {
  if (!value && value !== 0) {
    return <span className="text-muted fst-italic">—</span>;
  }

  // Formatage monétaire
  if (
    [
      "montant",
      "amount",
      "montant_ht",
      "prime_emission",
      "valeur_action",
      "montant_souscrit",
      "instalment",
      "non_utilization_fees",
    ].includes(key)
  ) {
    return (
      value
        ?.toLocaleString("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
        .replace("€", "") || "—"
    );
  }

  // Threshold avec logique spéciale
  if (key === "threshold") {
    if (typeof value === "string" && value.includes("%")) {
      return parseFloat(value)?.toLocaleString("fr-FR") + "%" || "—";
    }
    return parseFloat(value)?.toLocaleString("fr-FR") || "—";
  }

  return value;
};

export default TableComponent;
